module.exports = __webpack_public_path__ + "img/1723011759459-WhatsApp Image 2024-08-07 at 12.02.13.jpeg.ab836738.webp";